import { atom } from "recoil";

export const sangjoComparisonIdState = atom<undefined | number | null>({
  default: undefined,
  key: "sangjoComparisonIdState",
});
